var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryList } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { Router } from '@angular/router';
var PreReqDocumentComponent = /** @class */ (function () {
    function PreReqDocumentComponent(Util, Api, router, util) {
        this.Util = Util;
        this.Api = Api;
        this.router = router;
        this.util = util;
        this.DataSource1 = [];
        this.dtCon = null;
    }
    PreReqDocumentComponent.prototype.ngOnInit = function () {
        $('#Result').addClass("hidden");
    };
    PreReqDocumentComponent.prototype.CancelSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                $('#dpa_contact_id').val("");
                $('#dpa_contact_account').val("");
                return [2 /*return*/];
            });
        });
    };
    PreReqDocumentComponent.prototype.CreateTable1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, UserName, Password, dpa_contact_id, dpa_contact_account, QueryString, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        UserName = $('#dpa_contact_id').val();
                        Password = $('#dpa_contact_account').val();
                        if (UserName == "") {
                            this.util.WarningDialog("กรุณาระบุเลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี");
                            return [2 /*return*/];
                        }
                        if (Password == "") {
                            this.util.WarningDialog("กรุณาระบุหมายเลขบัญชี");
                            return [2 /*return*/];
                        }
                        dpa_contact_id = $("#dpa_contact_id").val();
                        dpa_contact_account = $("#dpa_contact_account").val();
                        QueryString = "CRM07=true&CRM03=true";
                        if (dpa_contact_id != "")
                            QueryString += "&dpa_id=" + dpa_contact_id;
                        if (dpa_contact_account != "")
                            QueryString += "&dpa_accountno=" + dpa_contact_account;
                        return [4 /*yield*/, this.Api.get("crmservice", "contactDros", QueryString)];
                    case 1:
                        Res = _a.sent();
                        if (Res == null) {
                            this.Util.WarningDialog("ไม่พบข้อมูล");
                            return [2 /*return*/];
                        }
                        if (Res.CRM03 == null || Res.CRM03.length == 0) {
                            this.Util.WarningDialog("ไม่พบข้อมูล เอกสารที่ขอได้");
                            return [2 /*return*/];
                        }
                        Res.CRM03 = Res.CRM03.filter(function (a) { return a.FilePath != null && a.FilePath != "" && a.FilePath.split('_')[1] != "05.pdf" && a.FilePath.split('_')[1] != "07.pdf"; });
                        if (Res.CRM03 == null || Res.CRM03.length == 0) {
                            this.Util.WarningDialog("ไม่พบข้อมูล เอกสารที่ขอได้");
                            return [2 /*return*/];
                        }
                        if (Res.CRM07 == null || Res.CRM07.length == 0) {
                            this.Util.WarningDialog("ไม่พบข้อมูล");
                            return [2 /*return*/];
                        }
                        else {
                            localStorage.setItem("cusid", dpa_contact_id);
                            localStorage.setItem("cusaccno", dpa_contact_account);
                            window.location.href = 'mainmenu/reqdocument';
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return PreReqDocumentComponent;
}());
export { PreReqDocumentComponent };



// WEBPACK FOOTER //
// ./src/app/pre-req-document/pre-req-document.component.ts.pre-build-optimizer.js